export abstract class BaseHTMLElement {
    protected element: HTMLElement;

    constructor(tagName: string, className?: string) {
        this.element = document.createElement(tagName);
        if (className) this.element.className = className;
    }

    public getElement(): HTMLElement {
        return this.element;
    }

    public setHTML(html: string): this {
        this.element.innerHTML = html;
        return this;
    }

    public addToDOM(parent: HTMLElement): this {
        parent.appendChild(this.element);
        return this;
    }

    public addEventListener(type: string, listener: EventListener): this {
        this.element.addEventListener(type, listener);
        return this;
    }
}